<template>
  <div class="login-page relative flex items-top justify-center min-h-screen items-center sm:pt-0">
    <div class="max-w-4xl mx-auto px-8" id="overlay">
      <a class="flex justify-center pt-8 sm:pt-0">
        <img class="logoimg" src="../assets/logo-white.png" />
      </a>
      <b-row>
        <div class="mt-2 bg-white overflow-hidden shadow rounded container">
          <!-- <b-col class="left-side bg-blue p-6" lg="4">
					<h3 class="heading">Water Monitoring System</h3>
					</b-col> -->
          <b-col class="right-side p-3" lg="12">
            <p class="justify-content-md-center mt-2" v-if="error_msg.length > 0">
              <b-alert show variant="danger">{{ error_msg }}</b-alert>
            </p>
            <h5 class="heading_title">Login to Dashboard</h5>
            <form class="mt-3" v-on:keyup.enter="login()">
              <b-form-group label="Username" label-for="mobile-input" invalid-feedback="Username should be valid">
                <b-form-input type="text" id="mobile-input" v-model="email"></b-form-input>
              </b-form-group>
              <b-form-group
                label="Password"
                label-for="password-input"
                invalid-feedback="Password should be greater than 4 digits"
              >
                <b-form-input type="password" id="password-input" v-model="password"></b-form-input>
              </b-form-group>
              <b-button type="submit" href="#" variant="primary" class="mr-3 submitbtn" @click="login()"
                >Login</b-button
              >
            </form>
          </b-col>
        </div>
      </b-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "Login",
  components: {},
  mounted() {
    //alert('hello');
  },
  data() {
    return {
      email: "",
      password: "",
      error_msg: "",
      url: this.$root.httpurl + "api-wms/login",
    };
  },
  methods: {
    login() {
      var self = this;

      self.axios
        .post(self.url, {
          email: self.email,
          pass: self.password,
        })
        .then(function(response) {
          if (response.data.error == 0 || response.data.error == "0") {
            console.log("response::", response);
            self.error_msg = "";
            self.$session.start();
            self.$session.set("access_key", response.data.result.access_key);
            console.log("response::", self.$session);

            var user_info = response.data.result;
            user_info.options = JSON.parse(response.data.result.options);

            user_info.permissions = JSON.parse(response.data.result.permissions);

            //user_info.options = JSON.parse(user_info.options);
            //console.log(JSON.stringify(user_info));

            /*self.$root.showMessage('Server Error', 'Reload again', 'ok', function(){
						alert('reload');
					});*/

            self.$session.set("user_info", user_info);

            self.$root.access_key = response.data.result.access_key;

            if (user_info.groups.length == 1) {
              self.$session.set("group_id", user_info.groups[0].id);
              self.$session.set("logo", user_info.groups[0].logo);
              self.$session.set("portal_name", user_info.groups[0].portal_name);
              self.$session.set("dashboard_pumps", user_info.groups[0].dashboard_pumps);
              self.$session.set("dashboard_waterlevel", user_info.groups[0].dashboard_waterlevel);
              self.$session.set("dashboard_pump_view", user_info.groups[0].dashboard_pump_view);

              self.$router.push("/" + user_info.dashboard);
            } else {
              self.$router.push("/main");
            }

            /*if(user_info.permissions.dashboard_link){
						self.$router.push(user_info.permissions.dashboard_link);
					}else{
						self.$router.push('/dashboard/waterlevel');
					}*/
          } else {
            self.error_msg = response.data.message;
          }
        })
        .catch(function(error) {
          alert(error);
        });
      //alert('login '+self.email+" "+self.password);
    },
  },
};
</script>

<style>
html {
  min-height: 100%;
}
body {
  /*background-image: url(../assets/background.jpg) !important;
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center center;*/
}
#overlay {
  background-color: #2e2d2d7e;
  padding: 50px;
  border-radius: 20px;
  box-shadow: rgb(255, 255, 255) 0px 2px 4px 0px, rgb(255, 255, 255) 0px 2px 16px 0px;
}
.login-page {
  /* background-color: #bebcbc !important; */
  background-image: url("../assets/image.jpg");
  background-size: cover;
}
b-form-group {
  /* padding: 20px; */
  width: 100% !important;
  color: rgb(94, 99, 99);
}
.submitbtn {
  float: right;
  margin-bottom: 20px;
  margin-right: 0px !important;
}
.heading_title {
  color: #5e5a5a;
  text-align: center;
  margin: auto;
}
.logoimg {
}
.mt-xl {
  margin-top: 100px;
}
.btn-black {
  background-color: #000;
  color: #817b7b;
  padding: 6px 25px;
}
</style>
